import { useState } from 'react';

import type { Dispatch, SetStateAction } from 'react';

/**
 * Row state for a JSON-body directive table, re-parsed whenever the markdown
 * source changes. While a message streams, the component mounts with a partial
 * (unparseable) body; only the prop — not a state initializer — sees the
 * completed JSON.
 *
 * @param jsonData - Raw JSON body of the directive.
 * @param parse - Parser returning the rows, or null when unparseable.
 * @returns The rows (null when unparseable) and their setter for inline edits.
 */
export function useParsedDirectiveRows<T>(
	jsonData: string | undefined,
	parse: (jsonData: string) => T[] | null,
): [T[] | null, Dispatch<SetStateAction<T[] | null>>] {
	const [rows, setRows] = useState<T[] | null>(() => (jsonData ? parse(jsonData) : null));
	const [prevJsonData, setPrevJsonData] = useState(jsonData);
	if (jsonData !== prevJsonData) {
		setPrevJsonData(jsonData);
		setRows(jsonData ? parse(jsonData) : null);
	}
	return [rows, setRows];
}
